import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  Fragment,
} from "react";
import { Link } from "react-router-dom";
import {
  getAppointments,
  updateAppointmentStatus,
} from "../API/AppointmentsApi";
import AuthContext from "../Context/AuthProvider";
import { compareDates, convertToUTC, convertUTCToTimeZone, convertUTCToTimeZoneDateTimeString } from "../Utility/DateTimeUtility";
import {
  AppointmentStatus,
  DateRangeOptions,
  PrescriptionTypes,
  ServiceStatus,
} from "../Utility/Constants";
import { Modal, Toast } from "bootstrap";
// import NewPrescription from "../Prescriptions/NewPrescription";
// import PrescriptionForm from "../Prescriptions/PrescriptionForm";
import { getDisplayValue, showLoadingImage } from "../Utility/Utility";
// import {
//   addPrescription,
//   getPrescription,
//   getPrescriptionsForAppointment,
//   updatePrescription,
// } from "../API/PrescriptionApi";
import { DataGrid, GridPinnedColumnPosition } from "@mui/x-data-grid";
import {
  Box,
  Button,
  Fab,
  Grid2,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  Card,
  CardContent,
  CardActions,
  Divider,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import EditCalendarOutlinedIcon from "@mui/icons-material/EditCalendarOutlined";
import dayjs from "dayjs";
import { Done, PlayCircleOutline, Undo } from "@mui/icons-material";
// import { getVisits } from "../API/VisitsApi";
import {
  getMyAssignedServices,
  updateServiceStatus,
} from "../API/LinkedServicesApi";
import { useSnackbar } from "../Utility/UserMessageContext";
import DateRangeDialog from "../Appointments/ChangeDates";
// import { PinnedColumnPosition } from "@mui/x-data-grid/internals";
import { formatAge } from "../Utility/Utility";




function MyWorlist({ onViewDetails, onAddNewPrescription, onAddNote, onAddMedicalRecord}) {
  const { auth } = useContext(AuthContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // const [searchedResultAppointments, setSearchedResultAppointments] =
  //   useState();
  // const [prescriptions, setPrescriptions] = useState();
  // const [searchableAppointments, setSearchableAppointments] = useState();
  // const [searchText, setSearchText] = useState();
  const [allAppointments, setAllAppointments] = useState([]);  // Initialize as empty array
  const [dataLoaded, setDataLoaded] = useState(false);  // Add a state to track if data has been loaded
  // const [flattendAppointments, setFlattendAppointments] = useState();
  const [selectedAppointment, setSelectedAppointment] = useState();
  //const [newStatus, setNewStatus] = useState();
  //const [errorMessage, setErrorMessage] = useState();
  const [showSpinner, setShowSpinner] = useState(false);
  // const todayDate = dayjs(new Date());
  const checkInPatientModalId = "checkIn" + selectedAppointment?.id;
  // const [currentPrescription, setCurrentPrescription] = useState();
  const [showQueue, setShowQueue] = useState();
  
  // const appointmentStatusList = [
  //   "Scheduled",
  //   "CheckedIn",
  //   "InProgress",
  //   "Cancelled",
  //   "Completed",
  //   "NoShow",
  // ];


    

  // const [prescriptionIdToBeEdited, setPrescriptionIdToBeEdited] = useState();
  // const [keyForRescheduleRendering, setKeyForRescheduleRendering] = useState(0);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);
  
  const handleMenuOpen = (event, row) => {
    setMenuAnchor(event.currentTarget);
    setCurrentRow(row); // Keep track of the selected row
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setCurrentRow(null);
  };

  const [filters, setFilters] = useState({
    from: dayjs(new Date()),
    to: dayjs(new Date()),
    selectedDateRangeOption: DateRangeOptions.Today,
  });

  const {showSnackbar} = useSnackbar();

  useEffect(() => {
    const fetchData = async () => {
      setShowSpinner(true);
      setDataLoaded(false);  // Reset data loaded state when fetching
      
      var result = await getMyAssignedServices(
        auth, 
        convertToUTC(dayjs(filters.from).set('hour',0).set('minute', 0).set('second', 0).set('millisecond', 0)), 
        convertToUTC(dayjs(filters.to).set('hour',23).set('minute', 59).set('second', 59).set('millisecond', 999)),
      );
      if (result.isSuccess) {
        setAllAppointments(result?.data || []);  // Set empty array if data is null/undefined
      } else {
        setAllAppointments([]);  // Set empty array in case of error
      }
      
      setDataLoaded(true);  // Mark data as loaded regardless of success/failure
      setShowSpinner(false);
    };

    fetchData();
  }, [auth, filters]);

  const [pageSize, setPageSize] = useState(5);

  // const showStatusUpdateModal = (newStatus) => {
  //   const modalElement = document.getElementById(checkInPatientModalId);
  //   if (modalElement) {
  //     setNewStatus(newStatus);
  //     const modal = new Modal(modalElement, {});
  //     modal.show();
  //     handleMenuClose();
  //   }
  // };

  // const showHideNewPrescriptionModal = (show) => {
  //   if (show) {
  //     const modalElement = document.getElementById("newPrescriptionModal");
  //     if (modalElement) {
  //       const modal = new Modal(modalElement, {});
  //       modal.show();
  //     }
  //   } else {
  //     const modal = Modal.getOrCreateInstance("#newPrescriptionModal");
  //     modal.hide();
  //   }
  // };

  // const rescheduleAppointment = () => {
  //   const modalElement = document.getElementById("changeAppointmentModal");
  //   if (modalElement) {
  //     const modal = new Modal(modalElement, {});
  //     modal.show();
  //     handleMenuClose();
  //   }
  // };

  // const resetRescheduleAppointmentForm = () => {
  //   setKeyForRescheduleRendering((prevKey) => prevKey + 1);
  // };

  // const savePrescription = async () => {
  //   var result = {};
  //   if (!prescriptionIdToBeEdited) {
  //     result = await addPrescription(
  //       auth,
  //       currentPrescription,
  //       selectedAppointment?.id,
  //       "draft"
  //     );
  //   } else {
  //     result = await updatePrescription(
  //       auth,
  //       currentPrescription,
  //       prescriptionIdToBeEdited,
  //       "draft"
  //     );
  //   }
  //   if (result.isSuccess) {
  //     showHideNewPrescriptionModal(false);
  //     //refreshList();
  //   } else {
  //     // return false;
  //   }
  // };

  const onStatusChanged = async (serviceId, newStatus) => {
    var result = await updateServiceStatus(auth, serviceId, newStatus);
    if (result.isSuccess) {
      refreshList();
    } else {
      showSnackbar(result?.data, "error");
    }
  };

  const refreshList = async () => {
    setShowSpinner(true);
    setDataLoaded(false);  // Reset data loaded state when refreshing
    
    var result = await getMyAssignedServices(
      auth, 
      convertToUTC(dayjs(filters.from).set('hour',0).set('minute', 0).set('second', 0).set('millisecond', 0)), 
      convertToUTC(dayjs(filters.to).set('hour',23).set('minute', 59).set('second', 59).set('millisecond', 999)),
    );
    
    if (result.isSuccess) {
      setAllAppointments(result?.data || []);  // Set empty array if data is null/undefined
    } else {
      setAllAppointments([]);  // Set empty array in case of error
    }
    
    setDataLoaded(true);  // Mark data as loaded regardless of success/failure
    setShowSpinner(false);
  };

  // Custom function to control when to show the "no rows" message
  const getNoRowsOverlay = () => {
    if (showSpinner || !dataLoaded) {
      // If still loading or data hasn't been loaded yet, don't show any message
      return '';
    }
    // Only show the message when data is loaded and there are no rows
    return 'There are no services to display. Change the dates to view your worklist.';
  };

  // Mobile card render function
 // Mobile card render function
const renderServiceCards = () => (
  <Grid2 container spacing={2} sx={{ width: '100%', maxHeight: 'calc(100vh - 170px)', overflowY: 'auto' }}>
  <Box sx={{ px: 1,  }}>
    {allAppointments.map((service) => (
      <Card key={service.id} variant="outlined" sx={{ mb: 2, borderRadius: 2 }}>
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
            <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1 }}>
              {`${service.patientPrefix || ''} ${service.patientFirstName || ''} ${service.patientLastName || ''}`.trim()}
            </Typography>
            <Chip 
              label={getDisplayValue(service.status)} 
              color={service.status === ServiceStatus.Completed ? "success" : 
                     service.status === ServiceStatus.InProgress ? "primary" : "default"}
              size="small"
            />
          </Box>
          
          <Divider sx={{ my: 1 }} />
          
          {/* Display everything one below another */}
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>ID:</strong> {service.displayId}
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Gender:</strong> {service.patientGender}
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Age:</strong> {formatAge(service.patientAgeInYears)}
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Contact:</strong> {service.patientMobileNo}
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Email:</strong> {service.patientEmailId}
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 1 }}>
            <strong>Service:</strong> {service.serviceName}
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 2 }}>
            <strong>Scheduled:</strong> {convertUTCToTimeZoneDateTimeString(service.scheduledStartDateTime, auth?.selectedFacility?.timeZone)}
          </Typography>
        </CardContent>
        
      <CardActions sx={{ justifyContent: "flex-end", px: 2, pb: 2, flexWrap: 'wrap', gap: 1 }}>
          <Tooltip title="View Details" arrow placement="top">
            <IconButton
              size="small"
              color="primary"
              onClick={() => onViewDetails(service)}
            >
              <EventNoteOutlinedIcon />
            </IconButton>
          </Tooltip>
          
          {service.status !== ServiceStatus.InProgress &&
            service.status !== ServiceStatus.Completed && (
              <Tooltip title="Start Service" arrow placement="top">
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => onStatusChanged(service.id, ServiceStatus.InProgress)}
                >
                  <PlayCircleOutline />
                </IconButton>
              </Tooltip>
            )}
          
          {(service.status === ServiceStatus.InProgress ||
            service.status === ServiceStatus.Completed) && (
              <Tooltip title="Undo Status" arrow placement="top">
                <IconButton
                  size="small"
                  color="secondary"
                  onClick={() => {
                    if (service.status === ServiceStatus.Completed) {
                      onStatusChanged(service.id, ServiceStatus.InProgress);
                    }
                    if (service.status === ServiceStatus.InProgress) {
                      onStatusChanged(service.id, ServiceStatus.NotStarted);
                    }
                  }}
                >
                  <Undo />
                </IconButton>
              </Tooltip>
            )}
          
          {service.status === ServiceStatus.InProgress && (
            <>
              <Tooltip title="Complete Service" arrow placement="top">
                <IconButton
                  size="small"
                  color="success"
                  onClick={() => onStatusChanged(service.id, ServiceStatus.Completed)}
                >
                  <Done />
                </IconButton>
              </Tooltip>
              
              <Tooltip title="Add Outcome" arrow placement="top">
                <IconButton
                  size="small"
                  color="default"
                  onClick={(event) => handleMenuOpen(event, service)}
                >
                  <AddRoundedIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </CardActions>
      </Card>
    ))}
    
    {dataLoaded && allAppointments.length === 0 && !showSpinner && (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          There are no services to display. Change the dates to view your worklist.
        </Typography>
      </Box>
    )}
    
    {showSpinner && (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Loading...
        </Typography>
      </Box>
    )}
  </Box>
  </Grid2>
);

  const columns = [
    { field: "displayId", headerName: "ID", width: 180 },
    { field: "visitDisplayId", headerName: "Visit #", width: 180 },
  
    {
      field: 'patient',
      type: 'text',
      headerName: ' Name',
      width: 180,
      // renderCell: (params) =>
      //   params?.row?.patientPrefix +
      //   " " +
      //   params?.row?.patientFirstName +
      //   " " +
      //   params?.row?.patientLastName +
      //   ", " +
      //   params?.row?.patientGender +
      //   ", " +
      //   params?.row?.patientAgeInYears,
      renderCell: (params) =>
        `${params.row.patientPrefix || ''} ${params.row.patientFirstName || ''} ${params.row.patientLastName || ''}`.trim(),
    },
    {
      field: 'patientGender',
      headerName: 'Gender',
      width: 100,
      renderCell: (params) => params.row.patientGender || '',
    },
    {
      field: 'patientAge',
      headerName: 'Age',
      width: 100,
      renderCell: (params) => formatAge(params.row.patientAgeInYears),
    },
    {
      field: "patientContact",
      type: "text",
      headerName: "Contact No",
      width: 130,
      renderCell: (params) =>
        params?.row?.patientMobileNo 
    },
    {
      field: "patientEmailId",
      type: "text",
      headerName: "Email Id",
      width: 170,
      renderCell: (params) => params?.row?.patientEmailId,
    },
    {
      field: "serviceName",
      headerName: "Service",
      width: 180,
      renderCell: (params) => params?.row?.primaryServiceName,
    },
    {
      field: "scheduledStartDateTime",
      headerName: "Scheduled Time",
      width: 220,
      valueGetter: (params) =>
        convertUTCToTimeZoneDateTimeString(params, auth?.selectedFacility?.timeZone)
    },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      renderCell: (params) => getDisplayValue(params?.row?.status),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 200,
      sortable: false,
      headerClassName: 'sticky-column',
      cellClassName: 'sticky-column',
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="View Details" arrow>
            <IconButton
              variant="outlined"
              onClick={() => onViewDetails(params?.row)}
            >
              <EventNoteOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          {params.row.status !== ServiceStatus.InProgress &&
            params.row.status !== ServiceStatus.Completed && (
              <Tooltip title="Start Service" arrow>
                <IconButton
                  variant="outlined"
                  onClick={() =>
                    onStatusChanged(params?.row?.id, ServiceStatus.InProgress)
                  }
                >
                  <PlayCircleOutline fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          {(params.row.status === ServiceStatus.InProgress ||
            params.row.status === ServiceStatus.Completed) && (
              <Tooltip title="Undo Status" arrow>
                <IconButton
                  variant="outlined"
                  onClick={() => {
                    if (params?.row?.status === ServiceStatus.Completed) {
                      onStatusChanged(
                        params?.row?.id,
                        ServiceStatus.InProgress
                      );
                    }
                    if (params?.row?.status === ServiceStatus.InProgress) {
                      onStatusChanged(
                        params?.row?.id,
                        ServiceStatus.NotStarted
                      );
                    }
                  }}
                >
                  <Undo fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          {params.row.status === ServiceStatus.InProgress && (
            <Fragment>
              <Tooltip title="Add Outcome" arrow>
                <IconButton
                  variant="outlined"
                  onClick={(event) => handleMenuOpen(event, params?.row)}
                >
                  <AddRoundedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Complete Service" arrow>
                <IconButton
                  variant="outlined"
                  onClick={() =>
                    onStatusChanged(params?.row?.id, ServiceStatus.Completed)
                  }
                >
                  <Done fontSize="small" />
                </IconButton>
              </Tooltip>
            </Fragment>
          )}
        </Box>
      ),
    },
  ];
  
  return (
    <>
      <Grid2 containe size={12}>
        <Grid2 container size={12} sx={{ marginX: "5px", marginY: "10px" }}>
          <Grid2  spacing={1} alignContent="center">
            <Grid2
              container
              alignItems="center"
              sx={{ flexWrap: "nowrap" }}
            >
              <Grid2 item sx={{ flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", }}>
                <Typography
                  variant="body1"
                  sx={{
                    xs:12,
                    sm:12,
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.875rem",
                      md: "1rem",
                      lg: "1.125rem",
                      xl: "1.25rem",
                    },
                  }}
                >
                  Showing worklist from {filters?.from?.format("DD/MM/YYYY")} to{" "}
                  {filters?.to?.format("DD/MM/YYYY")}
                </Typography>
              </Grid2>
 
              <Grid2 item>
                <Tooltip title="Change Dates" arrow>
                  <IconButton
                    color="secondary"
                    size="small"
                    onClick={() => setOpenDateRangeDialog(true)}
                    sx={{ paddingLeft: "0px" }}
                  >
                    <EditCalendarOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Grid2>
            </Grid2>
          </Grid2>
        </Grid2>

        {/* Conditional rendering based on screen size */}
        {isMobile ? (
          // Mobile Card View
          <Box sx={{ width: "100%", paddingX: "5px" }}>
            {renderServiceCards()}
          </Box>
        ) : (
          // Desktop DataGrid View

          <Grid2
            container size={12}
            sx={{
              maxHeight: "calc(100vh - 170px)", overflowY: "auto",
              display: "flex",
              width: showQueue ? "80%" : "100%",
              transition: "width 1s ease",
              paddingX: "5px",
              height: 600,
              //overflow: "auto", // Enable scrolling when content overflows
             // Adjust as needed for your layout
            }}
          >
            <DataGrid
              localeText={{
                noRowsLabel: getNoRowsOverlay(),
              }}
              loading={showSpinner || !dataLoaded}
              slotProps={{
                loadingOverlay: {
                  variant: "skeleton",
                  noRowsVariant: "skeleton",
                },
              }}
              initialState={{
                density: "compact",
                pagination: {
                  paginationModel: { pageSize: 5 },
                },
              }}
              sx={{
                width: "200px",
                overflow: "hidden",
                "& .sticky-column": {
                  position: "sticky",
                  right: 0,
                  backgroundColor: "white",
                  zIndex: 100,
                },
              }}
              rows={allAppointments}
              columns={columns}
              pageSizeOptions={[5, 10, 15]}
              rowsPerPageOptions={[5, 10, 15]}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            />
          </Grid2>
        )}
        
        {/* Menu for both mobile and desktop */}
        <Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={handleMenuClose}>
          {currentRow && currentRow.status === ServiceStatus.InProgress && (
            <>
              <MenuItem onClick={() => {onAddNewPrescription(currentRow?.id, PrescriptionTypes.GeneralPrescription);  
              handleMenuClose();}}>
                Add General Prescription
              </MenuItem>
              <MenuItem onClick={() => {onAddNewPrescription(currentRow?.id, PrescriptionTypes.PhysiotherapyPrescription);
              handleMenuClose();}}>
                Add Physiotherapy Prescription
              </MenuItem>
              <MenuItem onClick={() => {onAddMedicalRecord(currentRow?.id);
              handleMenuClose();}}>
                Add Medical Record
              </MenuItem>
              <MenuItem onClick={() => {
                onAddNote(currentRow?.id);
                handleMenuClose();
              }}>
                Add Note
              </MenuItem>
            </>
          )}
        </Menu>
      </Grid2>
      
      <DateRangeDialog
        key="worklist"
        title="Show Worklist For"
        filters={filters}
        setFilters={setFilters}
        openState={openDateRangeDialog}
        setOpenState={setOpenDateRangeDialog}
        // onApply={handleApplyDateRange}
      ></DateRangeDialog>
      {/* <div class="container-fluid">
        <div class="row justify-content-center align-items-center mt-4">
          <div
            class="modal"
            tabindex="-1"
            id={checkInPatientModalId}
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Change Status</h5>
                </div>
                <div class="modal-body">
                  <p>
                    You are changing the status of the appointment from{" "}
                    {selectedAppointment?.status} to {newStatus} for the patient
                    - {selectedAppointment?.patient?.firstName}. Are you sure?
                  </p>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    onClick={onStatusChanged}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default MyWorlist;
